<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.groupinglist.optional_groups')" :visible.sync="dialogVisible" width="40%" center>
      <div class="form-class">
        <el-form :model="modificationuser" ref="groupForm" label-width="160px" label-position="right" :rules="rules">
          <el-form-item :label="`${$t('lang.groupinglist.GroupName')}：`" prop="group_name">
            <el-input v-model="modificationuser.group_name" size="mini" style="width: 5rem" :disabled="disabled">
            </el-input>
          </el-form-item>
          <el-form-item v-if="modificationuser.n2nInfo && modificationuser.n2nInfo.n2nInfoStatus"
            :label="`${$t('lang.groupinglist.account_root')}：`" prop="n2nInfo.group_username">
            <el-input v-model="modificationuser.n2nInfo.group_username" size="mini" style="width: 5rem">
            </el-input>
          </el-form-item>
          <el-form-item v-if="modificationuser.n2nInfo && modificationuser.n2nInfo.n2nInfoStatus"
            :label="`${$t('lang.groupinglist.RemoteMailboxes')}：`" prop="n2nInfo.group_password">
            <el-input v-model="modificationuser.n2nInfo.group_password" size="mini" style="width: 5rem">
            </el-input>
          </el-form-item>
          <el-form-item v-if="modificationuser.n2nInfo && modificationuser.n2nInfo.n2nInfoStatus"
            :label="`${$t('lang.groupinglist.IPaux')}：`" prop="n2nInfo.edge_ip">
            <el-input v-model="modificationuser.n2nInfo.edge_ip" size="mini" style="width: 3rem"></el-input>
            /
            <el-input size="mini" style="width: 1.5rem;" v-model="modificationuser.n2nInfo.n2nIfnoMaskbit"></el-input>
          </el-form-item>
          <el-form-item v-if="modificationuser.n2nInfo && modificationuser.n2nInfo.n2nInfoStatus"
            :label="`${$t('lang.groupinglist.serverFeatures')}：`" prop="n2nInfo.edge_ip">
            <el-checkbox v-model="modificationuser.groupServiceDistribution"></el-checkbox>
          </el-form-item>
          <el-form-item v-if="modificationuser.n2nInfo && modificationuser.n2nInfo.n2nInfoStatus"
            :label="`${$t('lang.groupinglist.bridging')}：`" prop="n2nInfo.edge_ip">
            <el-checkbox @change="n2nInfoBridgeChange" :disabled="nenVersion < 4"
              v-model="modificationuser.n2nInfo.n2nInfoBridge"></el-checkbox>
            <p class="tips" v-if="nenVersion >= 4">
              {{ modificationuser.n2nInfo.n2nInfoBridge ? $t('lang.groupinglist.bridgePrompt') :
                $t('lang.groupinglist.bridgePrompt2') }}
            </p>
            <p class="tips" v-else>
              {{ $t('lang.groupinglist.bridgePrompt3') }}
            </p>
          </el-form-item>
          <el-form-item v-if="user_iscustomer != 0">
            <el-radio-group v-model="modificationuser.n2nInfo.n2nInfoLoginType">
              <el-radio :label="'0'">{{ $t('lang.groupinglist.DonotAllowmultiplelogins') }}</el-radio>
              <el-radio :label="'1'">{{ $t('lang.groupinglist.AllowMultipleLogins') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="modificationuser.n2nInfo.n2nInfoLoginType == '1'" label="最多登录数：">
            <el-input-number size="mini" v-model="modificationuser.n2nInfo.n2nInfoLoginNum" :min="2" :max="30"
              @change="SetNumber"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="hiden">{{ $t('lang.groupinglist.cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="confirmmodification">{{ $t('lang.groupinglist.Determine')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import { modifyGroupName, getN2nVersion } from "@/api/groupinglist";
import { cloneDeep } from "lodash";
export default {
  data() {
    // 检验表单账号密码
    const checkUserPWD = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('lang.groupinglist.notEmpty')))
      } else {
        // 校验是否存在中文
        let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi
        if (reg.exec(value)) {
          callback(new Error(this.$t('lang.groupinglist.userpwdChineseCheck')))
        } else if (value.length < 6 || value.length >= 18) {
          callback(new Error(this.$t('lang.groupinglist.message1')))
        } else {
          callback()
        }
      }
    }
    const checkIp = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('lang.groupinglist.ipInput')))
      } else {
        let iptest = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if (!iptest.test(value)) {
          callback(new Error(this.$t("lang.groupinglist.message3")))
        } else {
          callback()
        }
      }
    }
    return {
      dialogVisible: false,
      modificationuser: {
        n2nInfo: {
          n2nInfoStatus: 0,
          groupServiceDistribution: false
        },
        customer: {
          c_id: ""
        },
        groupParent: {
          group_id: null
        }
      },
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
      //修改分组二级选择框绑定
      setlevel1: { group_id: null },
      setlevel2: { group_id: null },
      //后端返回的分组列表
      queryResult: [],
      //用户选中获取到二级分组列表
      groupList: [],
      setsuperlink: null,
      //禁用状态
      disabled: false,
      setuid: null,
      UserList: [],
      rules: {
        group_name: [
          { required: true, message: this.$t('lang.groupinglist.groupNameInput'), trigger: 'blur' }
        ],
        'n2nInfo.group_username': [
          { validator: checkUserPWD, trigger: ['blur', 'change'] }
        ],
        'n2nInfo.group_password': [
          { validator: checkUserPWD, trigger: ['blur', 'change'] }
        ],
        'n2nInfo.edge_ip': [
          { validator: checkIp, trigger: ['blur', 'change'] }
        ],
        'n2nInfo.n2nIfnoMaskbit': [
          { required: true, message: this.$t('lang.groupinglist.maskbitInput'), trigger: ['blur', 'change'] }
        ]
      },
      groupLevelDetail: {},
      nenVersion: 0
    }
  },
  methods: {
    hiden() {
      this.clearData()
      this.dialogVisible = false
    },
    clearData() {
      this.modificationuser = {
        n2nInfo: {
          n2nInfoStatus: 0,
          n2nIfnoMaskbit: 24
        },
        customer: {
          c_id: ""
        },
        groupParent: {
          group_id: null
        }
      },
        this.queryResult = []
      this.groupList = []
      this.setlevel2 = { group_id: null }
      this.setlevel1 = { group_id: null }
      this.setsuperlink = null
    },
    async show(row) {
      this.clearData()
      // 深拷贝
      this.modificationuser = cloneDeep(row)
      if (!this.modificationuser.n2nInfo) {
        this.modificationuser.n2nInfo = {
          n2nInfoStatus: 0,
          n2nInfoBridge: false,
        }
      }
      if (this.modificationuser.n2nInfo.n2nIfnoMaskbit == undefined) {
        this.modificationuser.n2nInfo.n2nIfnoMaskbit = 24
      }
      this.modificationuser.n2nInfo.n2nInfoBridge = this.modificationuser.n2nInfo.n2nInfoBridge == 1
      if (!this.modificationuser.groupServiceDistribution) this.$set(this.modificationuser, 'groupServiceDistribution', false)
      this.modificationuser.groupServiceDistribution = this.modificationuser.groupServiceDistribution == 1
      // 默认分组不能修改一二级分组
      this.disabled = row.group_level == 0 ? true : false
      this.dialogVisible = true
    },
    //允许多处登录限制数量
    SetNumber() {
      if (this.modificationuser.n2nInfo.n2nInfoLoginNum == undefined) {
        this.$set(this.modificationuser.n2nInfo, 'n2nInfoLoginNum', 2)
      } else if (this.modificationuser.n2nInfo.n2nInfoLoginNum > 30) {
        this.$set(this.modificationuser.n2nInfo, 'n2nInfoLoginNum', 30)
      }
    },
    //确定修改上传
    confirmmodification() {
      this.$refs.groupForm.validate(valid => {
        let parentGroupId = this.modificationuser.groupPid;
        if (valid) {
          //上传修改后的分组信息
          modifyGroupName(
            this.modificationuser.group_id,
            this.modificationuser.group_name,
            this.modificationuser.group_level,
            parentGroupId,
            this.modificationuser.userGroups[0].user.user_id,
            this.modificationuser.customer ? this.modificationuser.customer.c_id : undefined,
            this.modificationuser.n2nInfo.n2nInfoStatus,
            this.modificationuser.n2nInfo.group_username,
            this.modificationuser.n2nInfo.group_password,
            this.modificationuser.n2nInfo.edge_ip,
            this.modificationuser.n2nInfo.n2nInfoLoginType,
            this.modificationuser.n2nInfo.n2nInfoLoginNum,
            this.modificationuser.n2nInfo.n2nInfoBridge ? 1 : 0,
            this.modificationuser.n2nInfo.n2nIfnoMaskbit,
            this.modificationuser.groupServiceDistribution ? 1 : 0
          ).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: this.$t("lang.groupinglist.message4"),
                type: "success"
              });
            } else if (res.data.code === 21) {
              this.$message({
                message: this.$t("lang.groupinglist.message5"),
                type: "warning"
              });
            } else if (res.data.code === 28) {
              this.$message({
                message: this.$t("lang.groupinglist.message6"),
                type: "warning"
              });
            } else if (res.data.code === 19) {
              this.$message({
                message: this.$t("lang.groupinglist.message7"),
                type: "warning"
              });
            } else {
              this.$message({
                message: this.$t("lang.groupinglist.message8"),
                type: "warning"
              });
            }
            this.$emit('queryKeyword')
            // 更新原来父级分组的数据和后来修改的父级分组的数据
            this.$emit('reFleshTable', parentGroupId)
            this.$emit('reFleshTable', this.modificationuser.groupPid)
            this.dialogVisible = false
          });
        } else {
          return false
        }
      })
    },
    n2nInfoBridgeChange() {
      if (this.modificationuser.n2nInfo.n2nInfoBridge) {
        this.modificationuser.n2nInfo.edge_ip = "192.168.1.1"
      } else {
        this.modificationuser.n2nInfo.edge_ip = "172.16.100.2"
      }
    }
  },
  watch: {
    'modificationuser.n2nInfo.n2nInfoN2nServerId': {
      handler(val, oldVal) {
        if (val) {
          getN2nVersion({ serverId: val }).then(res => {
            this.nenVersion = res.data.data.serverVersion
          })
        } else {
          this.n2nVersion = 0
        }
      },
      deep: true
    }
  },
}
</script>
<style scoped>
.form-item {
  margin-bottom: 10px;
}

.tetxp {
  display: inline-block;
  width: 4rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}

.tips {
  color: grey;
  line-height: 16px;
  max-width: 270px;
  font-size: 14px;
}

.form-class {
  display: flex;
  justify-content: center;
}
</style>